export const certifications = [
  {
    title: "SSC Marksheet",
    fileUrl: "/documents/certificates/ssc-marksheet.jpg"
  },
  {
    title: "Diploma Marksheet",
    fileUrl: "/documents/certificates/diploma-marksheet.jpg"
  },
  {
    title: "B.E. Passing Certificate",
    fileUrl: "/documents/certificates/be-passing-certificate.jpg"
  },
  {
    title: "LangChain - Develop LLM Powered Applications with LangChain",
    issuer: "Udemy",
    date: "Jan 2024",
    fileUrl: "/documents/certificates/langchain-udemy.pdf"
  },
  { title: "Data Science Training" },
  { title: "SQL Beginner To Advanced For Data Professionals" },
  { title: "Python For Beginner And Intermediate Learners" },
  { title: "Power BI Data Analytics For All Levels" },
  {
    title: "Complete Digital Marketing Course with Google",
    issuer: "Udemy",
    date: "Sep 2022",
    fileUrl: "/documents/certificates/digital-marketing-udemy.pdf"
  },
  { title: "Python Basic II" },
  { title: "Excel" },
  { title: "Capstone Project" },
  {
    title: "CCNA Routing and Switching",
    issuer: "I-Medita Learning Solutions",
    date: "Mar 2017",
    fileUrl: "/documents/certificates/ccna-routing-switching.pdf"
  },
  {
    title: "Tally & MS Office",
    issuer: "OIIT Computer Hardware Institute",
    date: "Apr 2018",
    grade: "80.50% (First Class)",
    fileUrl: "/documents/certificates/tally.jpg"
  },
  {
    title: "AutoCAD",
    issuer: "Nice Computer Institute of Technology & Design",
    grade: "A+",
    fileUrl: "/documents/certificates/autocad.jpg"
  },
  {
    title: "MS-CIT (Maharashtra State Certificate in IT)",
    issuer: "MSBTE / MKCL",
    date: "Jun 2013",
    grade: "93%",
    fileUrl: "/documents/certificates/mscit.jpg"
  },
  {
    title: "Govt. Certificate in Computer Typing — Hindi (30 WPM)",
    issuer: "Maharashtra State Council of Examination",
    date: "Jul 2023",
    grade: "Grade A (80%)",
    fileUrl: "/documents/certificates/typing-certificate.pdf"
  },
  {
    title: "Govt. Certificate in Computer Typing — English (40 WPM)",
    issuer: "Maharashtra State Council of Examination",
    date: "Dec 2023",
    grade: "Grade A (82%)",
    fileUrl: "/documents/certificates/typing-certificate.pdf"
  }
];
